<template>
    <div class="mx-2 flex flex-col gap-1 py-2" v-cloak>

        <div v-if="fetching" class="my-1 flex items-center justify-center gap-2">
            <span class="text-sm text-gray-100">Fetching...</span>
            <spinner />
        </div>

        <div v-if="!fetching" class="flex flex-col gap-1">

            <div class="uppercase text-xs text-center font-semibold mb-2">Total Games</div>
            <ul class="mb-4 flex flex-col gap-1">
                <li class="dark:bg-white dark:bg-opacity-5 mx-2 py-1 px-2 rounded">
                    <admin-chart style="height: 100px;" :data="daily_totals"></admin-chart>
                </li>
                <li v-for="(item, index) in games" class="flex flex-col mx-2 py-1 px-2 rounded text-sm"
                    :class="index % 2 == 0 ? 'bg-black bg-opacity-10 dark:bg-white dark:bg-opacity-10' : 'dark:bg-white dark:bg-opacity-5'">
                    <div class="flex items-center justify-between">
                        <div>{{ item.template.name }}</div>
                        <div>{{ item.total }}</div>
                    </div>
                </li>
                <li class="flex flex-col mx-2 py-1 px-2 rounded text-sm bg-inner-border/25">
                    <div class="flex items-center justify-between ">
                        <div class="uppercase">Total</div>
                        <div class="font-semibold">{{ totalGames }}</div>
                    </div>
                </li>
            </ul>

            <div class="uppercase text-xs text-center font-semibold">Entries</div>
            <ul class="mb-4 flex flex-col gap-1">
                <li v-for="(item, index) in entries" class="flex flex-col mx-2 py-1 px-2 rounded text-sm"
                    :class="index % 2 == 0 ? 'bg-black bg-opacity-10 dark:bg-white dark:bg-opacity-10' : 'dark:bg-white dark:bg-opacity-5'">
                    <div class="flex items-center justify-between">
                        <div>{{ item.subdomain !== null ? item.sponsor.name : 'Rumble Racers' }}</div>
                        <div>{{ item.total }}</div>
                    </div>
                </li>
                <li class="flex flex-col mx-2 py-1 px-2 rounded text-sm bg-inner-border/25">
                    <div class="flex items-center justify-between ">
                        <div class="uppercase">Total</div>
                        <div class="font-semibold">{{ totalEntries }}</div>
                    </div>
                </li>
            </ul>

            <div class="uppercase text-xs text-center font-semibold">Users</div>
            <ul class="mb-4 flex flex-col gap-1">
                <li class="flex flex-col mx-2 py-1 px-2 rounded text-sm bg-inner-border/25">
                    <div class="flex items-center justify-between ">
                        <div class="uppercase">Total</div>
                        <div class="font-semibold">{{ users }}</div>
                    </div>
                </li>
            </ul>

            <div class="uppercase text-xs text-center font-semibold">Top 10 Race Entries</div>
            <ul class="mb-4 flex flex-col gap-1">
                <li v-for="(item, index) in users_top_ten" class="flex flex-col mx-2 py-1 px-2 rounded text-sm"
                    :class="index % 2 == 0 ? 'bg-black bg-opacity-10 dark:bg-white dark:bg-opacity-10' : 'dark:bg-white dark:bg-opacity-5'">
                    <div class="flex items-center justify-between">
                        <div>{{ item.name }}</div>
                        <div>{{ item.total }}</div>
                    </div>
                </li>
            </ul>

        </div>
    </div>
</template>

<script>
import axios from 'axios'
import AdminChart from './AdminChart.vue'

export default {
    name: 'AdminSubPanelStats',
    props: ['token'],
    components: {
        AdminChart,
    },
    data() {
        return {
            fetching: false,
            games: [],
            entries: [],
            users: 0,
            daily_totals: {
                labels: [],
                values: []
            },
            users_top_ten: []
        }
    },
    computed: {
        totalGames() {
            return this.games.reduce((accumulator, currentValue) => accumulator + currentValue.total, 0);
        },
        totalEntries() {
            return this.entries.reduce((accumulator, currentValue) => accumulator + currentValue.total, 0);
        }
    },
    mounted() {
        this.fetching = true
        axios.get('/api/admin/stats', {
            headers: {
                'Authorization': `Bearer ${this.token}`
            }
        }).then((response) => {
            this.games = response.data.games
            this.entries = response.data.entries
            this.users = response.data.users
            this.daily_totals = response.data.daily_totals
            this.users_top_ten = response.data.users_top_ten
        }).catch(() => {
            this.$toast.error('Error fetching Stats.')
        }).finally(() => {
            this.fetching = false
        })
    }
}
</script>
